module.exports = __webpack_public_path__ + "static/img/pDR_last.2a4cfe7b.png";